<template>
    <div class="header">
        <div class="return_enter" v-if="hasEnter" @click="reEnter">
            <img src="../../../assets/img/enter_head_return.png" />
            <div class="enter">返回企业端</div>
        </div>
        <div class="return_home" v-if="hasProject" @click="fnRefresh('/index')">
            <img src="../../../assets/img/enter_head_return.png" />
            <div class="home">返回首页</div>
        </div>
        <div class="left_box">
            <div class="box_weather">
                <div class="swiper-container" v-if="Weather">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in Weather" :key="index">
                            <span>{{ item }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box_today">{{ date | fnFormatDate }}</div>
        </div>
        <div class="center-box" :title="title">{{ title }}</div>
        <div class="task" @click="fnRefresh('/task')">
            <img src="../../../assets/img/enter_head_task.png" />
            <div class="txt">任务</div>
        </div>
        <div class="message" @click="fnRefresh('/message')">
            <img src="../../../assets/img/enter_head_msg.png" />
            <div class="txt">
                消息
                <div class="count" v-if="msgCount > 0">{{ msgCount }}</div>
            </div>
        </div>
        <div class="set_box" v-if="!isXyzShow">
            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="set">
                    <img src="../../../assets/img/enter_head_set.png" />
                    <div class="txt">设置</div>
                </div>
                <el-dropdown-menu slot="dropdown"
                    style="background-color: rgba(9, 17, 32, 1);border: 1px solid rgba(29, 68, 149, 1);">
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="noticeVisible = true">电视APP公告</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="fnShowProjectXcxCode">小程序项目二维码</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="fnShowProjectAppCode">APP项目二维码</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="fnOpenDownLoad">下载中心</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="fnOpenPwd">修改密码</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="fnOpneAutomaticResignation">人员自动离场</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="fnOpneAutomaticDeparture">人员自动离岗</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div @click="fnOpneAutoSendPerson">人员自动下发</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided style="text-align: center">
                        <div style="display:block;" @click="logout">退出登录</div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <!-- 设置人员自动下发至门禁设备弹窗 -->
        <div class="dialog_notice" v-if="showAutoSendPerson">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="设置人员是否自动下发至门禁设备"
                :visible.sync="showAutoSendPerson" center style="text-align: center;z-index: 9999;">
                <div style="text-align: center">
                    <el-radio-group v-model="autoSendPerson">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="showAutoSendPerson = false"><span>取消</span></div>
                        <div class="search-btn" @click="fnAutoSendPerson"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
        
        <!-- 设置人员自动离岗弹窗 -->
        <div class="dialog_notice" v-if="showAutomaticDeparture">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="设置人员自动离岗天数"
                :visible.sync="showAutomaticDeparture" center style="text-align: center;z-index: 9999;">
                <div style="text-align: center">
                    <el-input style="width: 80%" type="textarea" :row="3" class="input" placeholder="请输入自动离岗天数"
                        v-model="automaticDeparture" size="large"></el-input>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="showAutomaticDeparture = false"><span>取消</span></div>
                        <div class="search-btn" @click="fnAutomaticDeparture"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>

        <!-- 设置人员自动离场弹窗 -->
        <div class="dialog_notice" v-if="showAutomaticResignation">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="设置人员自动离场天数"
                :visible.sync="showAutomaticResignation" center style="text-align: center;z-index: 9999;">
                <div style="text-align: center">
                    <el-input style="width: 80%" type="textarea" :row="3" class="input" placeholder="请输入自动离场天数"
                        v-model="automaticResignation" size="large"></el-input>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="showAutomaticResignation = false"><span>取消</span></div>
                        <div class="search-btn" @click="fnAutomaticResignation"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>

        <!-- 设置电视APP公告弹窗 -->
        <div class="dialog_notice" v-if="noticeVisible">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="设置公告信息"
                :visible.sync="noticeVisible" center style="text-align: center;z-index: 9999;">
                <div style="text-align: center">
                    <el-input style="width: 80%" type="textarea" :row="3" class="input" placeholder="请输入公告信息"
                        v-model="userInfo.notice" size="large"></el-input>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="noticeVisible = false"><span>取消</span></div>
                        <div class="search-btn" @click="fnShowProjectNotice"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 查看小程序二维码弹窗 -->
        <div class="dialog_weixin" v-if="showXcx">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="小程序项目二维码"
                :visible.sync="showXcx" center>
                <img :src="xcxQRcodeUrl" />
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="showXcx = false"><span>关闭</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 查看APP二维码弹窗 -->
        <div class="dialog_app" v-if="showApp">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="APP项目二维码"
                :visible.sync="showApp" center>
                <img :src="appQRcodeUrl" />
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="showApp = false"><span>关闭</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 修改密码 -->
        <div class="dialog_pwd" v-if="dialogEditPwd">
            <el-dialog title="修改密码" :custom-class="'animate__animated animate__fadeIn'" :modal="false"
                :visible.sync="dialogEditPwd" center>
                <el-form :model="formPwd">
                    <el-form-item label="旧密码" label-width="100px">
                        <el-input v-model="formPwd.old_password" show-password placeholder="请输入旧密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" label-width="100px">
                        <el-input v-model="formPwd.new_password" show-password placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item label="再次输入密码" label-width="100px">
                        <el-input v-model="formPwd.pass_again" show-password placeholder="请再次输入密码"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="dialogEditPwd=false"><span>取消</span></div>
                        <div class="search-btn" @click="fnEditPwd"><span>保存</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import APP from '@/utils/base';
    import request from '@/utils/request';
    import {
        removeToken,
        getUserInfo,
        setUserInfo,
        removeUserInfo,
        getToken,
        getEnterStatus,
        removeEnterStatus,
        getEnterToken,
        setActiveIndex
    } from '@/utils/auth';
    import http from 'axios';
    import Swiper from 'swiper';
    import store from '../../../store';
    import {
        fnCookie
    } from '@/utils/localStorage'
    export default {
        props: {
            hasProject: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                date: new Date(), // 当前时间
                userInfo: null, // 登录后缓存的用户信息
                hasEnter: null, // 是否从企业端登录
                title: '', // 项目名称
                Weather: [], // 天气
                noticeVisible: false, // 电视APP公告弹窗
                xcxQRcodeUrl: '', // 小程序二维码url
                showXcx: false, // 小程序二维码弹窗
                showApp: false, // app二维码弹窗
                appQRcodeUrl: '', // app二维码url
                showDownLoad: false, // 下载中心弹窗
                LoadData: [], // 下载中心数据
                dialogEditPwd: false,
                formPwd: {
                    old_password: '', // 旧密码
                    new_password: '', // 新密码
                    pass_again: '', // 二次密码
                },
                isXyzShow: false,
                showAutomaticResignation: false, // 人员自动离职窗口
                automaticResignation: null, // 人员自动离职（0为不开启，大于0为天数）
                showAutoSendPerson: false, // 人员自动离职窗口
                autoSendPerson: 0, // 人员自动下发（0:不开启，1:开启）
                
                showAutomaticDeparture: false, // 人员自动离岗窗口
                automaticDeparture: null, // 人员自动离岗（0为不开启，大于0为天数）
            };
        },
        components: {
            Swiper
        },
        computed: {
            msgCount() {
                return store.state.message.msgCount;
            },
        },
        created() {
            // 获取项目信息
            this.userInfo = getUserInfo();
            this.isXyzShow = getUserInfo().is_xyz ? true : false
            this.hasEnter = getEnterStatus();
            let _arr = [{
                    name: '电视APP',
                    system: 'android',
                    version: '1.0.0',
                    load: 'http://cqxtkj.oss-cn-chengdu.aliyuncs.com/Trivia/%E7%AD%91%E5%B7%A5%E5%8C%A0TV-App.apk'
                },
                {
                    name: '手机APP',
                    system: 'android',
                    version: '1.0.0',
                    load: ''
                },
                {
                    name: '手机APP',
                    system: 'ios',
                    version: '1.0.0',
                    load: ''
                }
            ];
            this.LoadData = _arr;
        },
        mounted() {
            this.fnInit();
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        methods: {
            fnOpneAutomaticDeparture() {
                request({
                        url: 'project/getProjectInfo',
                        method: 'GET'
                    })
                    .then(res => {
                        this.automaticDeparture = res.data.automatic_departure;
                        this.showAutomaticDeparture = true
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            
            fnAutomaticDeparture() {
            
                if (this.automaticDeparture < 1) {
                    this.automaticDeparture = null
                }
            
                request({
                        url: 'project/setAutomaticDeparture',
                        method: 'POST',
                        data: {
                            automatic_departure: this.automaticDeparture
                        }
                    })
                    .then(res => {
                        this.showAutomaticDeparture = false;
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.showAutomaticDeparture = false;
                        this.$message.error(err.data);
                    });
            },
            fnOpneAutomaticResignation() {
                request({
                        url: 'project/getProjectInfo',
                        method: 'GET'
                    })
                    .then(res => {
                        this.automaticResignation = JSON.parse(res.data.automatic_resignation);
                        this.showAutomaticResignation = true
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnAutomaticResignation() {

                if (this.automaticResignation < 1) {
                    this.automaticResignation = null
                }

                request({
                        url: 'project/setAutomaticResignation',
                        method: 'POST',
                        data: {
                            automatic_resignation: this.automaticResignation
                        }
                    })
                    .then(res => {
                        this.showAutomaticResignation = false;
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.showAutomaticResignation = false;
                        this.$message.error(err.data);
                    });
            },
            fnOpneAutoSendPerson() {
                request({
                        url: 'project/getProjectInfo',
                        method: 'GET'
                    })
                    .then(res => {
                        this.autoSendPerson = res.data.auto_send_person;
                        this.showAutoSendPerson = true
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnAutoSendPerson() {
                request({
                        url: 'project/setAutoSendPerson',
                        method: 'POST',
                        data: {
                            auto_send_person: this.autoSendPerson
                        }
                    })
                    .then(res => {
                        this.showAutoSendPerson = false;
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.showAutoSendPerson = false;
                        this.$message.error(err.data);
                    });
            },
            // 打开修改密码弹窗
            fnOpenPwd() {
                this.formPwd.old_password = ''
                this.formPwd.new_password = ''
                this.formPwd.pass_again = ''
                this.dialogEditPwd = true
            },
            // 修改密码 保存
            fnEditPwd() {
                if (!this.formPwd.old_password) return this.$message.warning('旧密码不能为空!')
                if (!this.formPwd.new_password) return this.$message.warning('新密码不能为空!')
                if (!this.formPwd.pass_again) return this.$message.warning('再次输入密码不能为空!')
                if (this.formPwd.new_password != this.formPwd.pass_again) return this.$message.warning('两次密码不一致,请重新输入!')
                let _obj = {
                    old_password: this.formPwd.old_password,
                    new_password: this.formPwd.new_password
                }
                request({
                    url: '/password/edit_project',
                    method: 'POST',
                    data: _obj
                }).then(res => {
                    this.$message.success(res.data + ',2秒后请重新登录!')
                    setTimeout(() => {
                        this.logout()
                    }, 2000)
                }).catch(err => {
                    this.$message.error(err.data)
                })
            },
            // 退出登录
            async logout() {
                await removeToken();
                removeUserInfo();
                if (getEnterToken()) {
                    removeEnterStatus();
                    this.$router.push({
                        path: '/enter'
                    });
                } else {
                    this.$router.push(`/login`);
                    location.reload();
                }
            },
            // 返回企业端
            async reEnter() {
                await removeToken();
                removeUserInfo();
                removeEnterStatus();
                this.$router.push({
                    path: '/enter'
                });
            },
            // 初始化
            fnInit() {
                // 天气接口初始化
                this.fnGetWeather();
                // 获取项目名
                this.title = getUserInfo().name;
                // 获取消息未读数据
                this.fnGetNotReadMessage();
                // 获取所有区域
                this.fnGetUploadRegion()
                // 获取当前时间
                let _that = this;
                this.timer = setInterval(function() {
                    _that.date = new Date();
                }, 1000);
            },
            // 获取上传区域列表
            fnGetUploadRegion() {
                request({
                    url: '/attendance/getUploadRegion',
                    method: 'GET'
                }).then(res => {
                    fnCookie('uploadRegion', res.data)
                }).catch(err => {
                    this.$message.error(err.data)
                })
            },
            // 查看小程序项目二维码
            fnShowProjectXcxCode() {
                if (!this.userInfo.xcx_code) {
                    this.$message.warning('该项目暂无小程序项目二维码，请联系管理人员生成小程序项目二维码');
                    return;
                }
                this.xcxQRcodeUrl = this.userInfo.xcx_code;
                this.showXcx = true;
            },
            // 查看app项目二维码
            fnShowProjectAppCode() {
                if (!this.userInfo.project_code) {
                    this.$message.warning('该项目暂无APP项目二维码，请联系管理人员生成APP项目二维码');
                    return;
                }
                this.appQRcodeUrl = this.userInfo.project_code;
                this.showApp = true;
            },
            // 修改编辑项目公告
            fnShowProjectNotice() {
                request({
                        url: 'project/editProject',
                        method: 'POST',
                        data: {
                            notice: this.userInfo.notice
                        }
                    })
                    .then(res => {
                        this.noticeVisible = false;
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.noticeVisible = false;
                        this.$message.error(err.data);
                    });
            },
            // 下载中心
            fnOpenDownLoad() {
                window.open('http://www.zgjkj.com/');
                // if (_url) {
                // 	window.open(_url);
                // } else {
                // 	this.$message.warning('暂无更新版本下载');
                // }
                // this.showDownLoad = false;
            },
            // 获取未读消息条数
            fnGetNotReadMessage() {
                request({
                        url: 'projectIndex/getUnReadNum',
                        method: 'GET'
                    })
                    .then(res => {
                        store.dispatch('ChageMsg', res.data.unread);
                    })
                    .catch(err => {
                        // this.$message.error(err.data)
                    });
            },
            // 路由跳转
            fnRefresh(_url) {
                setActiveIndex('0')
                store.dispatch('ChangeIndex', '0');
                if (_url === this.$route.path) {
                    this.$router.push({
                        path: '/redirect',
                        query: _url
                    });
                } else {
                    this.$router.push({
                        path: _url
                    });
                }
            },
            // 初始化天气轮播
            initSwiper() {
                new Swiper('.swiper-container', {
                    loop: true,
                    autoplay: true,
                    autoplayDisableOnInteraction: false,
                    direction: 'vertical',
                    observer: true,
                    observeParents: true,
                    onSlideChangeEnd: function(swiper) {
                        swiper.update();
                        mySwiper.startAutoplay();
                        mySwiper.reLoop();
                    }
                });
            },
            // 获取当前天气
            fnGetWeather() {
                request({
                        url: '/project/getWeather',
                        method: 'GET',
                        notLoading: true
                    })
                    .then(res => {
                        let _arr = [];
                        if (res.data.weather.length > 0) {
                            let _data = res.data.weather;
                            for (var i in _data) {
                                let _str = '';
                                if (i == 0) {
                                    _str = '今天 ' + _data[i].low + '℃~' + _data[i].high + '℃ ' + _data[i].text_day;
                                }
                                if (i == 1) {
                                    _str = '明天 ' + _data[i].low + '℃~' + _data[i].high + '℃ ' + _data[i].text_day;
                                }
                                if (i == 2) {
                                    _str = '后天 ' + _data[i].low + '℃~' + _data[i].high + '℃ ' + _data[i].text_day;
                                }
                                _arr.push(_str);
                            }
                            this.Weather = _arr;
                            this.$nextTick(() => {
                                // 调用天气轮播初始化
                                this.initSwiper();
                            })
                        }
                    })
                    .catch(err => {
                        // console.log(err.data.weather);
                        // this.$message.error(err.data.weather);
                    });
            },
        }
    };
</script>
<style lang="scss" scoped>
    @import '@/styles/mixin.scss';

    .header {
        width: 1920px;
        height: 120px;
        background-image: url(../../../assets/img/enter_head_line.png);
        background-size: 100%;
        background-position: 0 0;
        position: absolute;
        top: 0;
        left: 0;

        .return_enter {
            position: absolute;
            top: 14px;
            left: 8px;
            width: 100px;
            color: #9CF8FB;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(flex-start, center);

            img {
                width: 20px;
                height: 17px;
                margin-right: 5px;
            }
        }

        .return_home {
            position: absolute;
            top: 14px;
            left: 127px;
            width: 100px;
            color: #9CF8FB;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(flex-start, center);

            img {
                width: 20px;
                height: 17px;
                margin-right: 5px;
            }
        }

        .left_box {
            position: absolute;
            top: 11px;
            left: 262px;
            width: 160px;
            height: 50px;
            color: #9CF8FB;
            font-size: 14px;
            @include flex-box(center, center, column);

            .box_weather,
            .box_today {
                height: 25px;
                line-height: 25px;
                text-align: center;

                .swiper-container {
                    width: 160px;
                    height: 25px;
                    line-height: 25px;
                    overflow: hidden;
                }
            }
        }

        .center-box {
            position: absolute;
            left: 578px;
            top: 0;
            width: 760px;
            height: 70px;
            font-size: 40px;
            line-height: 90px;
            color: #9CF8FB;
            cursor: pointer;
            text-align: center;
            padding: 0 10px;
            @include text-overflow();
        }

        .task {
            top: 18px;
            left: 1690px;
            position: absolute;
            width: 55px;
            height: 20px;
            font-size: 14px;
            color: #9CF8FB;
            cursor: pointer;
            @include flex-box(flex-start, center);

            img {
                width: 16px;
                height: 18px;
                margin-right: 6px;
            }
        }

        .message {
            top: 18px;
            left: 1768px;
            position: absolute;
            width: 55px;
            height: 20px;
            font-size: 14px;
            color: #9CF8FB;
            cursor: pointer;
            @include flex-box(flex-start, center);

            img {
                width: 18px;
                height: 17px;
                margin-right: 6px;
            }

            .txt {
                position: relative;

                .count {
                    position: absolute;
                    background-color: rgba(255, 0, 0, 0.9);
                    width: 18px;
                    height: 18px;
                    line-height: 17px;
                    font-size: 12px;
                    text-align: center;
                    border-radius: 50%;
                    color: #ffffff;
                    font-size: 12px;
                    top: -6px;
                    right: -12px;
                }
            }
        }

        .set_box {
            top: 18px;
            left: 1849px;
            position: absolute;
            width: 55px;
            height: 20px;
            font-size: 14px;
            cursor: pointer;

            .set {
                color: #9CF8FB;
                @include flex-box(flex-start, center);

                img {
                    width: 17px;
                    height: 17px;
                    margin-right: 6px;
                    float: left;
                }
            }
        }
    }

    >>>.el-dropdown-menu__item--divided {
        border-top: rgba(29, 68, 149, 0.3);
        color: rgba(156, 248, 251, 0.8);
    }

    >>>.el-dropdown-menu__item--divided::before {
        background-color: rgba(29, 68, 149, 0.3);
        height: 0;
    }

    >>>.popper__arrow {
        border-bottom-color: rgba(29, 68, 149, 1) !important;
    }

    .dialog_notice,
    .dialog_weixin,
    .dialog_app,
    .dialog_down,
    .dialog_pwd {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 800px;
            height: 500px;
            margin-top: 20vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4DB4F4;
        }

        >>>.el-dialog__title {
            color: #4DB4F4;
        }

        >>>.el-dialog__close {
            color: #4DB4F4;
        }
    }

    .dialog_pwd {
        >>>.el-dialog {
            width: 600px;
            height: 350px;
            margin-top: 25vh !important;
        }

        >>>.el-input__inner {
            width: 380px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background-color: rgba(77, 180, 244, 0.2);

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }
    }

    .dialog_notice {
        >>>.el-dialog {
            width: 700px;
            height: 220px;
            margin-top: 25vh !important;
        }

        >>>.el-textarea__inner {
            max-height: 325px;
        }
    }

    .dialog_weixin,
    .dialog_app {
        >>>.el-dialog {
            width: 510px;
            height: 720px;
        }

        img {
            width: 460px;
        }
    }

    .dialog_down {
        >>>.el-dialog {
            width: 715px;
            height: 450px;
        }

        .cont_list {
            width: 665px;
            height: 275px;
            color: #FFFFFF;
            font-size: 16px;
            border-radius: 10px;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 665px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 148px;
                        margin-right: 2px;
                        margin-left: 30px;
                    }

                    &:nth-child(2) {
                        width: 146px;
                        margin: 0 2px;
                    }

                    &:nth-child(3) {
                        width: 146px;
                        margin: 0 2px;
                    }

                    &:nth-child(4) {
                        width: 149px;
                        margin-left: 2px;
                        margin-right: 30px;
                    }
                }
            }

            .list_boxes {
                width: 605px;
                height: 225px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 605px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1D4495;
                        @include flex-box(flex-start, center);

                        .list_item {
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 148px;
                                margin-right: 2px;
                            }

                            &:nth-child(2) {
                                width: 146px;
                                margin: 0 2px;
                            }

                            &:nth-child(3) {
                                width: 146px;
                                margin: 0 2px;
                            }

                            &:nth-child(4) {
                                width: 149px;
                                margin-left: 2px;
                            }

                            div {
                                @include flex-box(center, center);

                                .item_btn {
                                    width: 69px;
                                    height: 32px;
                                    line-height: 32px;
                                    margin: 0 2px;
                                    font-size: 14px;
                                    color: #ffffff;
                                    border: none;
                                    cursor: pointer;
                                    background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                    background-size: 100% 100%;
                                    @include flex-box(center, center);

                                    span {
                                        margin-top: -2px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Header/HeaderDefault/headerProjectSelect.vue